import { useAtom } from 'jotai';
import { reportDownloadSnackbarMessage } from '@/state';
import { Snackbar } from './Snackbar';

export const ReportDownloadSnackbarProvider = () => {
  const [snackbarMessage, setSnackbarMessage] = useAtom(reportDownloadSnackbarMessage);

  const closeSnack = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarMessage({ shouldShow: false, content: undefined });
  };

  const { shouldShow, content, persistent, duration } = snackbarMessage;

  return (
    <Snackbar 
      sxProps={{ top: '56px !important' }} 
      open={shouldShow} 
      onClose={closeSnack}
      persistent={persistent}
      autoHideDuration={duration}
    >
      {content}
    </Snackbar>
  );
};
